import type { ReactElement } from 'react';
import { useEffect } from 'react';
import HeapAnalytics from 'services/HeapAnalytics';

import PromoBanner from 'components/shared/PromoBanner';

import img from 'consumer/account/upcoming-menus/promo-banners/less-prep/dish@1x.png';
import imgwebp from 'consumer/account/upcoming-menus/promo-banners/less-prep/dish@1x.webp';
import img2x from 'consumer/account/upcoming-menus/promo-banners/less-prep/dish@2x.png';
import imgwebp2x from 'consumer/account/upcoming-menus/promo-banners/less-prep/dish@2x.webp';

import { Component as BoilIcon } from 'consumer/account/upcoming-menus/promo-banners/less-prep/boil.svg';
import { Component as ChopIcon } from 'consumer/account/upcoming-menus/promo-banners/less-prep/chop.svg';
import { Component as CookIcon } from 'consumer/account/upcoming-menus/promo-banners/less-prep/cook.svg';
import { Component as TimeIcon } from 'consumer/account/upcoming-menus/promo-banners/less-prep/time.svg';
import { Component as ThunderboltIcon } from 'consumer/icons/thunderbolt.svg';

type Props = {
  id: number,
};

function LessPrepBanner({ id }: Props): ReactElement {
  useEffect(() => {
    HeapAnalytics.track('LessPrep_banner_viewed');
  }, []);

  const onClose = () => {
    HeapAnalytics.track('LessPrep_banner_closed');
  };

  const onClick = () => {
    HeapAnalytics.track('LessPrep_banner_clicked');
  };

  return (
    <PromoBanner theme="lessprep" id={id} onClose={onClose}>
      <>
        <div className="c-promo-banner__hero">
          <span className="c-promo-banner__badge">
            NEW!
          </span>
          <h1 className="c-promo-banner__heading mt-4">
            <span>Less  Prep meals</span>
          </h1>
          <span className="c-promo-banner__lead">
            <span className="d-md-block">Reduce prep and&nbsp;</span>
            <span className="d-md-block">cleanup time for&nbsp;</span>
            even easier cooking
          </span>
        </div>
        <div className="c-promo-banner__info">
          <picture>
            <source srcSet={`${imgwebp} 1x, ${imgwebp2x} 2x`} type="image/webp" />
            <source srcSet={`${img} 1x, ${img2x} 2x`} type="image/png" />
            <img src={img} alt="" loading="lazy" />
          </picture>

          <div className="ml-0 ml-sm-3">
            <ul className="c-promo-banner__points">
              <li>
                <TimeIcon />
                <span>
                  Less
                  <br />
                  Chopping
                </span>
              </li>
              <li>
                <ChopIcon />
                <span>
                  Pre-made
                  <br />
                  Sauces
                </span>
              </li>
              <li>
                <BoilIcon />
                <span>
                  Less pots
                  <br />
                  and pans
                </span>
              </li>
              <li>
                <CookIcon />
                <span>Delicious!</span>
              </li>
            </ul>
            <a href="/less-prep" onClick={onClick}>
              <ThunderboltIcon height="22px" width="22px" viewBox="0 0 10 14" />
              Learn more about
              <abbr>
                Less Prep
              </abbr>
              meals
            </a>
          </div>
        </div>
      </>
    </PromoBanner>
  );
}

export default LessPrepBanner;
